export default __webpack_public_path__ + "static/media/mastercard.52122ce2.png";